import {Component, OnInit} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MatError, MatHint} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {PaymentService} from "../../services/payment/payment.service";
import {ActivatedRoute} from "@angular/router";

@Component({
	selector: 'app-payment-successful',
	imports: [
		FormsModule,
	],
	templateUrl: './payment-successful.component.html',
	styleUrl: './payment-successful.component.sass'
})
export class PaymentSuccessfulComponent implements OnInit {
	constructor(private paymentService: PaymentService,
				private route: ActivatedRoute) {
	}

	ngOnInit() {
		console.log('init')
		this.route.queryParams.subscribe(params => {
			if (params['token']) {
				console.log('token', params['token']);
				this.paymentService.confirmPayPal(params['token']).subscribe(
					() => {

					}, () => {

					}
				)
			}
		})
	}
}
